/**
 * Info popin panel participants
 * @param {object} datas
 * @param {string} datas.textBegin
 * @param {string} datas.textEnd
 * @param {string} datas.jsClass
 * @param {boolean} datas.hasToDisplayPhoneNumber
 * @return {string} - Formatted HTML
 */
export const infoPopinPanelParticipants = (datas) => {
  const textBegin = datas.textBegin;
  const textEnd = datas.textEnd;
  const jsClass = datas.jsClass && datas.jsClass !== '' ? datas.jsClass : false;
  const urlContact = datas.urlContact;
  const hasToDisplayPhoneNumber = datas.hasToDisplayPhoneNumber;

  let htmlInfoPopinPanelParticipants = `
    <div class="qb--container">
    <span class="qb--buttonCloseMobile"><i class="icon icon-close js-closeMessage"></i></span>
    <div class="qb--content">
      ${textBegin},
      <a${jsClass === ' js-contactezNous' ? 'href="' + urlContact + '" target="_blank"' : ''} class="mainLink${jsClass}" data.urlcontact="${urlContact}">${textEnd}.</a>
    </div>
  `;
  if (hasToDisplayPhoneNumber) {
    htmlInfoPopinPanelParticipants += `
    <div class="qb--content">
      <a href="${GLOBAL_SCRIPTS.WORDINGS_COMMON.headernav_phone_number}" target="_self" class="button button--transparentBlack js-Tracking--link" data-tracking='{"clickCode":"clickAccommodationBreadcrumb","gaCategory":"${PAGE_SCRIPTS.page_template}","gaAction":"Multicottage-Popin accommodation","gaLabel":"View- number phone"}'>
        <i class="icon icon-phone"></i><span>${GLOBAL_SCRIPTS.WORDINGS_COMMON.headernav_phone_number}</span>
      </a>
      <span class="qb--number">${GLOBAL_SCRIPTS.WORDINGS_COMMON.headernav_phone_price}</span>
    </div>`;
  }
  htmlInfoPopinPanelParticipants += '</div>';

  return htmlInfoPopinPanelParticipants;
};